class LinkValidation {

  // Retrieve YouTube video id from video link
  isYoutube(url) {
    let fullUrl = /^.*youtu.*(be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?\s]*).*/;
    let id = /([^/#&?.=\s]{11})/;
    let match = url.match(fullUrl);
    let matchId = url.match(id);

    if (match && match[2] && match[2].length == 11) {
      return match[2];
    } else if (url.length == 11 && matchId) {
      return matchId[1];
    } else {
      return null;
    }
  }

  isSoundcloud(url) {
    let fullUrl = /^.*soundcloud\.com\/.*/;
    return url.match(fullUrl) ? url : null;
  }

  isInstagram(url) {
    let fullUrl = /^.*insta.*\/p\/([^#&?/]*).*/;
    let id = /([^/#&?.=\s]{11})/;
    let match = url.match(fullUrl);
    let matchId = url.match(id);

    if (match) {
      return match[1];
    } else if (url.length == 11 && matchId) {
      return matchId[1];
    } else {
      return null;
    }
  }

  isValid(url) {
    return this.isYoutube(url) || this.isInstagram(url) || this.isSoundcloud(url) || null;
  }
}

const linkValidation = new LinkValidation();
export default linkValidation;
